//# sourceMappingURL=cache.mjs.map
/// <reference types="./cache.d.mts" />
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../../gleam_stdlib/gleam/dict.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../../gleam_stdlib/gleam/pair.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $murmur3a from "../../../../murmur3a/murmur3a.mjs";
import {
  Ok,
  toList,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
} from "../../../gleam.mjs";
import * as $sketch_string from "../../../sketch/internals/string.mjs";

const FILEPATH = "src/sketch/internals/cache/cache.gleam";

export class Class extends $CustomType {
  constructor(as_string, content, name) {
    super();
    this.as_string = as_string;
    this.content = content;
    this.name = name;
  }
}
export const Class$Class = (as_string, content, name) =>
  new Class(as_string, content, name);
export const Class$isClass = (value) => value instanceof Class;
export const Class$Class$as_string = (value) => value.as_string;
export const Class$Class$0 = (value) => value.as_string;
export const Class$Class$content = (value) => value.content;
export const Class$Class$1 = (value) => value.content;
export const Class$Class$name = (value) => value.name;
export const Class$Class$2 = (value) => value.name;

class Definitions extends $CustomType {
  constructor(medias, selectors, class$) {
    super();
    this.medias = medias;
    this.selectors = selectors;
    this.class = class$;
  }
}

class ComputedClass extends $CustomType {
  constructor(id, name, class_name, definitions) {
    super();
    this.id = id;
    this.name = name;
    this.class_name = class_name;
    this.definitions = definitions;
  }
}

class Cache extends $CustomType {
  constructor(cache, at_rules) {
    super();
    this.cache = cache;
    this.at_rules = at_rules;
  }
}

export class AtRule extends $CustomType {
  constructor(as_string, rule, content) {
    super();
    this.as_string = as_string;
    this.rule = rule;
    this.content = content;
  }
}
export const AtRule$AtRule = (as_string, rule, content) =>
  new AtRule(as_string, rule, content);
export const AtRule$isAtRule = (value) => value instanceof AtRule;
export const AtRule$AtRule$as_string = (value) => value.as_string;
export const AtRule$AtRule$0 = (value) => value.as_string;
export const AtRule$AtRule$rule = (value) => value.rule;
export const AtRule$AtRule$1 = (value) => value.rule;
export const AtRule$AtRule$content = (value) => value.content;
export const AtRule$AtRule$2 = (value) => value.content;

export class Global extends $CustomType {
  constructor(class$) {
    super();
    this.class = class$;
  }
}
export const Global$Global = (class$) => new Global(class$);
export const Global$isGlobal = (value) => value instanceof Global;
export const Global$Global$class = (value) => value.class;
export const Global$Global$0 = (value) => value.class;

export class AtRuleClasses extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const AtRuleContent$AtRuleClasses = ($0) => new AtRuleClasses($0);
export const AtRuleContent$isAtRuleClasses = (value) =>
  value instanceof AtRuleClasses;
export const AtRuleContent$AtRuleClasses$0 = (value) => value[0];

export class AtRuleContent extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const AtRuleContent$AtRuleContent = ($0) => new AtRuleContent($0);
export const AtRuleContent$isAtRuleContent = (value) =>
  value instanceof AtRuleContent;
export const AtRuleContent$AtRuleContent$0 = (value) => value[0];

export class ClassName extends $CustomType {
  constructor(class$) {
    super();
    this.class = class$;
  }
}
export const Style$ClassName = (class$) => new ClassName(class$);
export const Style$isClassName = (value) => value instanceof ClassName;
export const Style$ClassName$class = (value) => value.class;
export const Style$ClassName$0 = (value) => value.class;

export class Media extends $CustomType {
  constructor(query, styles) {
    super();
    this.query = query;
    this.styles = styles;
  }
}
export const Style$Media = (query, styles) => new Media(query, styles);
export const Style$isMedia = (value) => value instanceof Media;
export const Style$Media$query = (value) => value.query;
export const Style$Media$0 = (value) => value.query;
export const Style$Media$styles = (value) => value.styles;
export const Style$Media$1 = (value) => value.styles;

export class Selector extends $CustomType {
  constructor(selector, styles) {
    super();
    this.selector = selector;
    this.styles = styles;
  }
}
export const Style$Selector = (selector, styles) =>
  new Selector(selector, styles);
export const Style$isSelector = (value) => value instanceof Selector;
export const Style$Selector$selector = (value) => value.selector;
export const Style$Selector$0 = (value) => value.selector;
export const Style$Selector$styles = (value) => value.styles;
export const Style$Selector$1 = (value) => value.styles;

export class Combinator extends $CustomType {
  constructor(selector, class$, styles) {
    super();
    this.selector = selector;
    this.class = class$;
    this.styles = styles;
  }
}
export const Style$Combinator = (selector, class$, styles) =>
  new Combinator(selector, class$, styles);
export const Style$isCombinator = (value) => value instanceof Combinator;
export const Style$Combinator$selector = (value) => value.selector;
export const Style$Combinator$0 = (value) => value.selector;
export const Style$Combinator$class = (value) => value.class;
export const Style$Combinator$1 = (value) => value.class;
export const Style$Combinator$styles = (value) => value.styles;
export const Style$Combinator$2 = (value) => value.styles;

export class Property extends $CustomType {
  constructor(key, value, important) {
    super();
    this.key = key;
    this.value = value;
    this.important = important;
  }
}
export const Style$Property = (key, value, important) =>
  new Property(key, value, important);
export const Style$isProperty = (value) => value instanceof Property;
export const Style$Property$key = (value) => value.key;
export const Style$Property$0 = (value) => value.key;
export const Style$Property$value = (value) => value.value;
export const Style$Property$1 = (value) => value.value;
export const Style$Property$important = (value) => value.important;
export const Style$Property$2 = (value) => value.important;

export class NoStyle extends $CustomType {}
export const Style$NoStyle = () => new NoStyle();
export const Style$isNoStyle = (value) => value instanceof NoStyle;

class Properties extends $CustomType {
  constructor(properties, medias, selectors, indentation) {
    super();
    this.properties = properties;
    this.medias = medias;
    this.selectors = selectors;
    this.indentation = indentation;
  }
}

class MediaProperty extends $CustomType {
  constructor(query, properties, selectors) {
    super();
    this.query = query;
    this.properties = properties;
    this.selectors = selectors;
  }
}

class SelectorProperty extends $CustomType {
  constructor(selector, properties) {
    super();
    this.selector = selector;
    this.properties = properties;
  }
}

export function classes_rule(rule, content) {
  let as_string = $string.inspect(content);
  let content$1 = new AtRuleClasses(content);
  return new AtRule(as_string, rule, content$1);
}

export function content_rule(rule, content) {
  let as_string = content;
  let content$1 = new AtRuleContent(content);
  return new AtRule(as_string, rule, content$1);
}

export function new$() {
  return new Cache($dict.new$(), $dict.new$());
}

function get_definitions(class$) {
  let $ = class$.definitions;
  let medias = $.medias;
  let selectors = $.selectors;
  let class$1 = $.class;
  let _pipe = toList([toList([class$1]), selectors, medias]);
  return $list.flatten(_pipe);
}

/**
 * Render a valid CSS StyleSheet from a cache.
 */
export function render_sheet(cache) {
  let _pipe = $dict.values(cache.at_rules);
  let _pipe$1 = $list.append(
    _pipe,
    $list.flat_map(
      $dict.values(cache.cache),
      (c) => { return get_definitions(c[0]); },
    ),
  );
  return $string.join(_pipe$1, "\n\n");
}

export function class$(content) {
  let as_string = $string.inspect(content);
  return new Class(as_string, content, new None());
}

export function named(name, content) {
  let as_string = $string.inspect(content);
  return new Class(as_string, content, new Some(name));
}

function wrap_selectors(id, indentation, selectors) {
  return $list.map(
    selectors,
    (selector) => {
      let selector$1 = selector.selector;
      let properties = selector.properties;
      return $sketch_string.wrap_class(
        id,
        properties,
        indentation,
        new Some(selector$1),
      );
    },
  );
}

function compute_classes(id, name, properties) {
  let class_name$1 = $option.lazy_unwrap(name, () => { return "css-" + id; });
  let name$1 = $option.lazy_unwrap(name, () => { return ".css-" + id; });
  let properties$1 = properties.properties;
  let medias = properties.medias;
  let selectors = properties.selectors;
  let class$1 = $sketch_string.wrap_class(name$1, properties$1, 0, new None());
  let selectors$1 = wrap_selectors(name$1, 0, selectors);
  return new ComputedClass(
    id,
    name$1,
    class_name$1,
    new Definitions(
      $list.map(
        medias,
        (_use0) => {
          let query = _use0.query;
          let properties$2 = _use0.properties;
          let selectors$2 = _use0.selectors;
          let selectors$3 = wrap_selectors(name$1, 2, selectors$2);
          let _pipe = toList([
            query + " {",
            $sketch_string.wrap_class(name$1, properties$2, 2, new None()),
          ]);
          let _pipe$1 = ((_capture) => {
            return $list.prepend(toList([selectors$3, toList(["}"])]), _capture);
          })(_pipe);
          let _pipe$2 = $list.flatten(_pipe$1);
          return $string.join(_pipe$2, "\n");
        },
      ),
      selectors$1,
      class$1,
    ),
  );
}

function compute_hash(to_hash) {
  let _pipe = $murmur3a.hash_string(to_hash, 1);
  return $murmur3a.hex_digest(_pipe);
}

function merge_computed_properties(target, argument) {
  return new Properties(
    $list.append(argument.properties, target.properties),
    $list.append(argument.medias, target.medias),
    $list.append(argument.selectors, target.selectors),
    target.indentation,
  );
}

function compute_property(indent, key, value, important) {
  let base_indent = $sketch_string.indent(indent);
  let _block;
  if (important) {
    _block = " !important";
  } else {
    _block = "";
  }
  let important$1 = _block;
  return ((((base_indent + key) + ": ") + value) + important$1) + ";";
}

function handle_property(props, property) {
  let key;
  let value;
  let important;
  if (property instanceof Property) {
    key = property.key;
    value = property.value;
    important = property.important;
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "sketch/internals/cache/cache",
      243,
      "handle_property",
      "Pattern match failed, no pattern matched the value.",
      {
        value: property,
        start: 7133,
        end: 7189,
        pattern_start: 7144,
        pattern_end: 7178
      }
    )
  }
  let css_property = compute_property(props.indentation, key, value, important);
  let properties = listPrepend(css_property, props.properties);
  return new Properties(
    properties,
    props.medias,
    props.selectors,
    props.indentation,
  );
}

function empty_computed() {
  let definitions = new Definitions(toList([]), toList([]), "");
  return new ComputedClass("", "", "", definitions);
}

function handle_combinator(cache, props, combinator, existing_selector) {
  let selector;
  let class$1;
  let styles;
  if (combinator instanceof Combinator) {
    selector = combinator.selector;
    class$1 = combinator.class;
    styles = combinator.styles;
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "sketch/internals/cache/cache",
      285,
      "handle_combinator",
      "Pattern match failed, no pattern matched the value.",
      {
        value: combinator,
        start: 8551,
        end: 8613,
        pattern_start: 8562,
        pattern_end: 8600
      }
    )
  }
  let indentation = props.indentation + 2;
  let $ = computed_class(class$1, cache);
  let cache$1 = $[0];
  let class$2 = $[1];
  let selector$1 = (existing_selector + selector) + class$2.name;
  let $1 = compute_properties(cache$1, styles, indentation, selector$1);
  let cache$2 = $1[0];
  let properties = $1[1];
  let selector$2 = new SelectorProperty(selector$1, properties.properties);
  let selectors = listPrepend(selector$2, properties.selectors);
  let selectors$1 = $list.append(selectors, props.selectors);
  return [
    cache$2,
    new Properties(
      props.properties,
      props.medias,
      selectors$1,
      props.indentation,
    ),
  ];
}

function handle_selector(cache, props, selector, existing_selector) {
  let selector$1;
  let styles;
  if (selector instanceof Selector) {
    selector$1 = selector.selector;
    styles = selector.styles;
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "sketch/internals/cache/cache",
      268,
      "handle_selector",
      "Pattern match failed, no pattern matched the value.",
      {
        value: selector,
        start: 7944,
        end: 7994,
        pattern_start: 7955,
        pattern_end: 7983
      }
    )
  }
  let indentation = props.indentation + 2;
  let selector$2 = existing_selector + selector$1;
  let $ = compute_properties(cache, styles, indentation, selector$2);
  let cache$1 = $[0];
  let properties = $[1];
  let selector$3 = new SelectorProperty(selector$2, properties.properties);
  let selectors = listPrepend(selector$3, properties.selectors);
  let selectors$1 = $list.append(selectors, props.selectors);
  return [
    cache$1,
    new Properties(
      props.properties,
      props.medias,
      selectors$1,
      props.indentation,
    ),
  ];
}

function handle_media(cache, props, media) {
  let query;
  let styles;
  if (media instanceof Media) {
    query = media.query;
    styles = media.styles;
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "sketch/internals/cache/cache",
      254,
      "handle_media",
      "Pattern match failed, no pattern matched the value.",
      {
        value: media,
        start: 7462,
        end: 7503,
        pattern_start: 7473,
        pattern_end: 7495
      }
    )
  }
  let indentation = props.indentation + 2;
  let $ = compute_properties(cache, styles, indentation, "");
  let cache$1 = $[0];
  let properties = $[1];
  let properties$1 = properties.properties;
  let selectors = properties.selectors;
  let medias = listPrepend(
    new MediaProperty(query, properties$1, selectors),
    props.medias,
  );
  return [
    cache$1,
    new Properties(props.properties, medias, props.selectors, props.indentation),
  ];
}

/**
 * The Style data structure being a recursive data, `compute_properties`
 * traverse the data structure and collect the properties with their context.
 * 
 * @ignore
 */
function compute_properties(cache, properties, indentation, existing_selector) {
  let init = new Properties(toList([]), toList([]), toList([]), indentation);
  return $list.fold(
    $list.reverse(properties),
    [cache, init],
    (_use0, p) => {
      let cache$1 = _use0[0];
      let acc = _use0[1];
      if (p instanceof ClassName) {
        let class$1 = p.class;
        let $ = $dict.get(cache$1.cache, class$1.as_string);
        if ($ instanceof Ok) {
          let props = $[0][1];
          return [cache$1, merge_computed_properties(acc, props)];
        } else {
          let _pipe = compute_properties(
            cache$1,
            class$1.content,
            indentation,
            "",
          );
          return $pair.map_second(
            _pipe,
            (_capture) => { return merge_computed_properties(acc, _capture); },
          );
        }
      } else if (p instanceof Media) {
        return handle_media(cache$1, acc, p);
      } else if (p instanceof Selector) {
        return handle_selector(cache$1, acc, p, existing_selector);
      } else if (p instanceof Combinator) {
        return handle_combinator(cache$1, acc, p, existing_selector);
      } else if (p instanceof Property) {
        return [cache$1, handle_property(acc, p)];
      } else {
        return [cache$1, acc];
      }
    },
  );
}

function insert_class_in_cache(cache, class$) {
  let $ = compute_properties(cache, class$.content, 2, "");
  let cache$1 = $[0];
  let properties = $[1];
  let hash = compute_hash(class$.as_string);
  let class_ = compute_classes(hash, class$.name, properties);
  let key = $option.unwrap(class$.name, class$.as_string);
  let cache_ = $dict.insert(cache$1.cache, key, [class_, properties]);
  return [new Cache(cache_, cache$1.at_rules), class_];
}

function computed_class(class$, cache) {
  return $bool.lazy_guard(
    $list.is_empty(class$.content),
    () => { return [cache, empty_computed()]; },
    () => {
      let existing_class = $dict.get(cache.cache, class$.as_string);
      if (existing_class instanceof Ok) {
        let class$1 = existing_class[0][0];
        return [cache, class$1];
      } else {
        return insert_class_in_cache(cache, class$);
      }
    },
  );
}

export function class_name(class$, cache) {
  return $pair.map_second(
    computed_class(class$, cache),
    (class$) => { return class$.class_name; },
  );
}

export function at_rule(rule, cache) {
  let $ = $dict.get(cache.at_rules, rule.as_string);
  if ($ instanceof Ok) {
    return cache;
  } else {
    let _block;
    let $1 = rule.content;
    if ($1 instanceof AtRuleClasses) {
      let classes = $1[0];
      let _pipe = $list.map(
        classes,
        (class$) => {
          let $2 = compute_properties(cache, class$.content, 2, "");
          let properties = $2[1];
          let _block$1;
          let _pipe = class$.as_string;
          let _pipe$1 = compute_hash(_pipe);
          _block$1 = compute_classes(_pipe$1, class$.name, properties);
          let class_ = _block$1;
          return class_.definitions.class;
        },
      );
      let _pipe$1 = $list.map(
        _pipe,
        (s) => {
          let _pipe$1 = $string.split(s, "\n");
          let _pipe$2 = $list.map(
            _pipe$1,
            (_capture) => { return $string.append("  ", _capture); },
          );
          return $string.join(_pipe$2, "\n");
        },
      );
      let _pipe$2 = $string.join(_pipe$1, "\n\n");
      let _pipe$3 = ((_capture) => {
        return $list.prepend(toList(["}"]), _capture);
      })(_pipe$2);
      let _pipe$4 = $list.prepend(_pipe$3, ("@" + rule.rule) + " {");
      _block = $string.join(_pipe$4, "\n");
    } else {
      let content = $1[0];
      _block = ((("@" + rule.rule) + " {") + content) + "}";
    }
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $dict.insert(cache.at_rules, rule.as_string, _capture);
    })(_pipe);
    return ((at_rules) => { return new Cache(cache.cache, at_rules); })(_pipe$1);
  }
}
